import { render, staticRenderFns } from "./RestBreakCancelled.vue?vue&type=template&id=78e5ffcf&"
import script from "./RestBreakCancelled.vue?vue&type=script&lang=js&"
export * from "./RestBreakCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports